import { useGetGlobalApiPaymentsDetails } from '@data/global-api-payments';

import type { UseGetPaymentDetailsParams } from './useGetPaymentDetails.types';

export const useGetPaymentDetails = (params: UseGetPaymentDetailsParams) =>
  useGetGlobalApiPaymentsDetails({
    ...params,
    voltApp: 'scaApp',
  });
